import { Utils } from 'formiojs';
import { form as template } from 'src/formio/templates/dropdownComponent/form';

const compiledForm = Utils.Evaluator.template(template, 'dropDownComponent');
export const formioDropdownComponentCustomTemplate = (ctx: any) => {
    return compiledForm(ctx);
};
